import { helper } from '@ember/component/helper';
import { sanitize } from 'cio/utils/sanitize';
import { config } from 'cio/helpers/preview-whitelist';

export function sanitizeHtml([html]: [string]) {
  return sanitize(html, config);
}

export default helper(sanitizeHtml);
